/* Firebase Functions handle + the public enquiry submitter. */
import { getFunctions, httpsCallable } from 'firebase/functions'
import { app } from './firebase.js'

export const functions = getFunctions(app, 'us-central1')

// Submit a confidential brief. Resolves on success, throws on
// validation / rate-limit errors (message is safe to show).
export async function submitEnquiry(payload) {
  const call = httpsCallable(functions, 'submitEnquiry')
  const res = await call(payload)
  return res.data
}
